import React, { useState, useEffect, useCallback } from "react";
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import QUERY_CREATORS from "../../graphql/queries/Creators/QueryCreators.js";
import { NotSeeingItems } from "../../components/NotSeeingItems.js";

import {
  Button,
  SelectMenu,
  Spinner
} from 'evergreen-ui';

function SelectCreator(props) {
  const currentpublisher = useSelector((state) => state.currentpublisher.value);

  const [creatorSelected, setCreatorSelected] = useState("");
  const [creators, setCreators] = useState([]);


  const { loading, error, data, refetch: _refetch} = useQuery(QUERY_CREATORS, {
    variables: { publisher: parseInt(currentpublisher.id) },
  });

  const refetch = useCallback(() => { setTimeout(() => _refetch(), 0) }, [_refetch]);


  useEffect(() => {
    if (data) {
      // Enhanced logic for sales by region
      if (props.parent === "royalties" && props.enableSalesByRegion) {
        // For each creator, check if they have at least one product/region combo without a royalty
        const filteredCreators = data.creators.filter(creator => {
          // Build a set of [productId, regionId] for existing royalties
          const royaltyCombos = creator.royaltySet.map(royalty => {
            const regionId = royalty.region ? String(royalty.region.id) : "null";
            return `${royalty.product.id}::${regionId}`;
          });
          // For each product, check if there is a royalty for every region
          // If there is at least one product/region combo without a royalty, include this creator
          let hasAvailableCombo = false;
          creator.productcreatorSet.forEach(item => {
            if (item.product.frozen) return;
            // Check for all possible regions (including null for Rest of World)
            // We'll assume the UI will handle region selection after creator is picked
            // So just check if there is any region combo missing
            // For now, just check for Rest of World (null) as a minimum
            const restOfWorldCombo = `${item.product.id}::null`;
            if (!royaltyCombos.includes(restOfWorldCombo)) {
              hasAvailableCombo = true;
            }
            // Optionally, if you want to check for all regions, you could pass available regions as a prop
            // and loop through them here
          });
          return hasAvailableCombo;
        });
        setCreators(filteredCreators);
      } else if (props.parent === "royalties") {
        // Original logic
        const filteredCreators = data.creators.filter(creator => {
          let existingRoyalties = creator.royaltySet.map(royalty => royalty.product.id)
          let productSet = creator.productcreatorSet.filter(item => !existingRoyalties.includes(item.product.id) && !item.product.frozen)
          return productSet.length > 0
        })
        setCreators(filteredCreators)
      }
      else {
        setCreators(data.creators.filter(item => item.royaltySet.filter(royalty => !royalty.product.frozen).length > 0))
      }
    }
  }, [data, props.parent, props.enableSalesByRegion]);

  useEffect(() => {
    refetch()
  },[props.royalties, refetch])

  if (loading) return (
        <Button disabled={true}>Loading Creators<Spinner marginLeft={8} size={12}/></Button>
);
  if (error) return `Error! ${error}`;

  return (
    <SelectMenu
      title=""
      titleView={({ close, headerHeight }) => {
        return (
          <NotSeeingItems headerHeight={headerHeight} close={close} items="creators" parentItem={props.parent}/>
        )
      }}
      options={creators.map((item) => ({
        key: "creator" + item.id,
        label: `${item.displayName} ${item.paymentName ? "(" + item.paymentName + ")" : ""}`,
        value: JSON.stringify(item),
        button: item.displayName
      }))}
      selected={creatorSelected}
      closeOnSelect={true}
      onSelect={(option) => {
        setCreatorSelected(option.button)
        props.handleNewCreator(option.value)
      }}>
      <Button>{creatorSelected ? creatorSelected : 'Select Creator...'}</Button></SelectMenu>
  )
}

export default SelectCreator;
